export const circ = (timeFraction: number) => 1 - Math.sin(Math.acos(timeFraction));
